export * from './entities-selectors'



/** WEBPACK FOOTER **
 ** ./src/selectors/entities/index.js
 **/